import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import {
  IdentityPermissionApi,
  permissionApiRef,
} from '@backstage/plugin-permission-react';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  createApiFactory({
    api: permissionApiRef,
    deps: {
      config: configApiRef,
      discovery: discoveryApiRef,
      identity: identityApiRef,
    },
    factory: ({ config, discovery, identity }) =>
      IdentityPermissionApi.create({ config, discovery, identity }),
  }),
  ScmAuth.createDefaultApiFactory(),
];
